export const AssetKeys = {
  TitleBackground: "title-background",
  ArenaBackground: "arena-background",
  PlayerAtlas: "player-atlas",
  SkeletonAtlas: "skeleton-atlas",
  SkeletonKingAtlas: "skeleton-king-atlas",
  Fireball: "fireball",
} as const;
